import { render, staticRenderFns } from "./Cateringprogram.vue?vue&type=template&id=53e6fdf5&scoped=true&"
import script from "./Cateringprogram.vue?vue&type=script&lang=js&"
export * from "./Cateringprogram.vue?vue&type=script&lang=js&"
import style0 from "./Cateringprogram.vue?vue&type=style&index=0&id=53e6fdf5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6fdf5",
  null
  
)

export default component.exports